define('OutSystems/ClientRuntime/ScriptsManager',["require", "exports", "./Logger", "./Settings"], function (require, exports, Logger, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.scheduleCustomJsLoading = exports.addScript = exports.getNumberOfScriptLoadRetries = exports.setNumberOfScriptLoadRetries = exports.clearScripts = void 0;
    var SCRIPT_FINISHED_ATTR = "data-os-finished";
    var SCRIPTS_MANAGER_MODULE_NAME = "ScriptsManager";
    var managedScripts = new Map();
    function clearScripts() {
        managedScripts.clear();
        lastAddedScript = null;
    }
    exports.clearScripts = clearScripts;
    function createScriptElement(scriptURL, dom) {
        var scriptElement = dom.createElement("script");
        scriptElement.async = false;
        scriptElement.setAttribute("src", scriptURL);
        scriptElement.setAttribute(SCRIPT_FINISHED_ATTR, "false");
        return scriptElement;
    }
    function retryOnErrorScript(dom, scriptElement, scriptURL, onFinish, retriesLeft, onRetry) {
        return new Promise(function (resolve, reject) {
            if (retriesLeft === 0) {
                onFinish();
                reject("Error adding script '" + scriptURL + "' to document '" + dom.baseURI + "'. No retries left.");
                scriptElement.parentNode.removeChild(scriptElement);
                lastAddedScript = null;
                return;
            }
            onRetry === null || onRetry === void 0 ? void 0 : onRetry();
            trace("Error while loading script", scriptURL, "\nRetrying...");
            var newScript = createScriptElement(scriptURL, dom);
            newScript.onerror = function () {
                retryOnErrorScript(dom, newScript, scriptURL, onFinish, retriesLeft - 1, onRetry)
                    .then(resolve)
                    .catch(reject);
            };
            newScript.onabort = scriptElement.onabort;
            newScript.onload = scriptElement.onload;
            var scriptParentNode = scriptElement.parentNode;
            var scriptNextSibling = scriptElement.nextElementSibling;
            scriptElement.parentNode.removeChild(scriptElement);
            if (scriptNextSibling) {
                scriptParentNode.insertBefore(newScript, scriptNextSibling);
            }
            else {
                scriptParentNode.appendChild(newScript);
            }
        });
    }
    var numberOfScriptLoadRetries = 3;
    function setNumberOfScriptLoadRetries(value) {
        Logger.trace(SCRIPTS_MANAGER_MODULE_NAME, "Setting number of script's load retries to " + value);
        numberOfScriptLoadRetries = value;
    }
    exports.setNumberOfScriptLoadRetries = setNumberOfScriptLoadRetries;
    function getNumberOfScriptLoadRetries() {
        return numberOfScriptLoadRetries;
    }
    exports.getNumberOfScriptLoadRetries = getNumberOfScriptLoadRetries;
    var initialized = false;
    var lastAddedScript = null;
    function addScript(scriptURL, onRetry, dom) {
        if (dom === void 0) { dom = document; }
        trace("Adding script", scriptURL);
        initialize(dom);
        var scriptInfo = managedScripts.get(scriptURL);
        if (scriptInfo) {
            trace("Script already added", scriptURL);
            return scriptInfo.promise;
        }
        var scriptElement = createScriptElement(scriptURL, dom);
        var loadScriptPromise = new Promise(function (resolve, reject) {
            var onFinish = function () {
                scriptElement.setAttribute(SCRIPT_FINISHED_ATTR, "true");
            };
            scriptElement.onerror = function () {
                var numRetries = Settings_1.getEnvParams().CDNFilenameVersioning ? numberOfScriptLoadRetries : 0;
                retryOnErrorScript(dom, scriptElement, scriptURL, onFinish, numRetries, onRetry)
                    .then(resolve)
                    .catch(reject);
            };
            scriptElement.onabort = function () {
                onFinish();
                reject("Aborted due to user action. Error adding script '" + scriptURL + "' to document '" + dom.baseURI + "'");
            };
            scriptElement.onload = function (ev) {
                trace("Script added", scriptURL);
                onFinish();
                resolve(ev);
            };
        });
        if (lastAddedScript) {
            lastAddedScript.domElement.parentNode.insertBefore(scriptElement, lastAddedScript.domElement.nextSibling);
        }
        else {
            dom.head.appendChild(scriptElement);
        }
        managedScripts.set(scriptURL, {
            promise: loadScriptPromise,
            domElement: scriptElement,
        });
        lastAddedScript = managedScripts.get(scriptURL);
        return loadScriptPromise;
    }
    exports.addScript = addScript;
    function trace(message, script, extraInfo) {
        if (extraInfo === void 0) { extraInfo = ""; }
        Logger.trace(SCRIPTS_MANAGER_MODULE_NAME, message + " '" + script + "' : document '" + document.baseURI + "'" + extraInfo);
    }
    function initialize(dom) {
        if (initialized) {
            return;
        }
        initialized = true;
        Object.defineProperty(define, "amd", {
            get: hideRequireDependingOnCaller.bind(this, define.amd, dom),
            configurable: true,
        });
    }
    function hideRequireDependingOnCaller(amd, dom) {
        var thisScript = dom.currentScript;
        if (thisScript && thisScript.hasAttribute(SCRIPT_FINISHED_ATTR)) {
            return undefined;
        }
        return amd;
    }
    function scheduleCustomJsLoading(urls, onErrorLoadingScript, onRetryLoadingScript, dom) {
        if (dom === void 0) { dom = document; }
        return Promise.all(urls.map(function (s) { return addScript(s, onRetryLoadingScript, dom).catch(onErrorLoadingScript); }));
    }
    exports.scheduleCustomJsLoading = scheduleCustomJsLoading;
});
//# sourceMappingURL=ScriptsManager.js.map;
